export const storeName = 'subscription';

export default {};
